import styled from 'styled-components'

export const MenuButton = styled.button`
  display: flex;
  padding: 7px;
`
